const initialToastOptions = {
  display: false,
  message: 'none',
  timeout: 0,
};

export const requestSuccessToast = (state = initialToastOptions, action) => Object.assign(
  {},
  { ...state, toastOptions: action.payload },
);

export const dismissSuccessToast = (state, action) => Object.assign(
  {},
  { ...state, toastOptions: action.payload },
);
